import * as React from 'react';
import { IBackgroundJobInfo } from '../../../ts/resources/BackgroundJobs';
import { toggleBackgroundJobExtendedInfoDialog } from '../../actions/spaces/ToggleBackgroundJobExtendedInfoDialog';
import { appStore } from '../../AppStore';

export class BackgroundJobExtendedInfoDialogCell extends React.Component<IBackgroundJobInfo> {

  private readonly toggleDilog = () => {
    appStore.dispatch(toggleBackgroundJobExtendedInfoDialog(this.props));
  }

  render() {
    return <>
      <a data-tb-test-id="data-grid-cell-text" onClick={this.toggleDilog} role="button">
        {this.props.jobId + ''}
      </a>
    </>;
  }
}
